import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Error alert component
 * @param {Object} props - Component props
 * @param {string} props.message - Error message to display
 * @param {string} props.className - Optional additional CSS classes
 */
const ErrorAlert = ({ message, className = '' }) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();

  if (!message) return null;
  
  return (
    <div className={`${semantic.highlightDangerBg} ${semantic.highlightDangerBorder} ${semantic.highlightDangerText} px-4 py-3 rounded relative ${className}`} role="alert">
      <div className="flex items-start">
        <div className="py-1">
          <svg className={`fill-current h-6 w-6 ${semantic.highlightDangerText} mr-4`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
          </svg>
        </div>
        <div>
          <p className="font-bold">{replace('Error')}</p>
          <p className="text-sm">{replace(message)}</p>
        </div>
      </div>
    </div>
  );
};

ErrorAlert.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ErrorAlert;

